import {platformBrowserDynamic} from "@angular/platform-browser-dynamic";
//import {decorateModuleRef} from './platform/environment';
import {AppModule} from "./app/app.module";


//declare var __webpack_public_path__:any;

/*
* Bootstrap our Angular app with a top level component `App` and inject
* our Services and Providers into Angular's dependency injection
*/
platformBrowserDynamic()
	.bootstrapModule(AppModule)
	// check if this can indeed be removed after moving to the cli
	//.then(decorateModuleRef)
	.catch(err => console.error(err));

/*
	* HMR capabilities removed - expiremental feature by AngularClass
	* which stongly couples into our source
	*/
// if ('development' === ENV) {// && HMR === true) {
// 	// activate hot module reload
// 	//   let ngHmr = require('angular2-hmr');
// 	//   ngHmr.hotModuleReplacement(main, module);
// 	document.addEventListener('DOMContentLoaded', () => main());
// } else {
// 	// bootstrap when documetn is ready
// 	document.addEventListener('DOMContentLoaded', () => main());
// }
//
// switch (document.readyState) {
// 	case 'loading':
// 		document.addEventListener('DOMContentLoaded', _domReadyHandler, false);
// 		break;
// 	case 'interactive':
// 	case 'complete':
// 	default:
// 		main();
// }
//
// function _domReadyHandler() {
// 	document.removeEventListener('DOMContentLoaded', _domReadyHandler, false);
// 	main();
// }
//
// if (__ris_global_vars__.version) {
// 	__webpack_public_path__ = __ris_global_vars__.baseResourceUrl + __ris_global_vars__.version+"/";
// }else {
// 	__webpack_public_path__ = __ris_global_vars__.baseResourceUrl + "/";
// }
